import type { CropVarietyConfiguration, CropVarietyConfigurationsByKey } from "./types.js";
import { almondVarietyConfigurations } from "./varieties/almond.js";
import { appleVarietyConfigurations } from "./varieties/apple.js";
import { avocadoVarietyConfigurations } from "./varieties/avocado.js";
import { blackberryVarietyConfigurations } from "./varieties/blackberry.js";
import { blueberryVarietyConfigurations } from "./varieties/blueberry.js";
import { boysenberryVarietyConfigurations } from "./varieties/boysenberry.js";
import { cherryVarietyConfigurations } from "./varieties/cherry.js";
import { citrusVarietyConfigurations } from "./varieties/citrus.js";
import { customVarietyConfigurations } from "./varieties/custom.js";
import { grapeVarietyConfigurations } from "./varieties/grape.js";
import { hazelnutVarietyConfigurations } from "./varieties/hazelnut.js";
import { loganberryVarietyConfigurations } from "./varieties/loganberry.js";
import { pistachioVarietyConfigurations } from "./varieties/pistachio.js";
import { raspberryVarietyConfigurations } from "./varieties/raspberry.js";
import { strawberryVarietyConfigurations } from "./varieties/strawberry.js";
import { tayberryVarietyConfigurations } from "./varieties/tayberry.js";
import { walnutVarietyConfigurations } from "./varieties/walnut.js";

export const CropVarietyConfigurations = {
    ...grapeVarietyConfigurations,
    ...appleVarietyConfigurations,
    ...cherryVarietyConfigurations,
    ...pistachioVarietyConfigurations,
    ...almondVarietyConfigurations,
    ...walnutVarietyConfigurations,
    ...hazelnutVarietyConfigurations,
    ...blueberryVarietyConfigurations,
    ...blackberryVarietyConfigurations,
    ...boysenberryVarietyConfigurations,
    ...loganberryVarietyConfigurations,
    ...tayberryVarietyConfigurations,
    ...raspberryVarietyConfigurations,
    ...strawberryVarietyConfigurations,
    ...citrusVarietyConfigurations,
    ...avocadoVarietyConfigurations,
    ...customVarietyConfigurations,
} as const satisfies CropVarietyConfigurationsByKey;

/** Returns the configuration for a known variety key, or `undefined` for an unknown one. */
export function getCropVarietyConfiguration(key: string): CropVarietyConfiguration | undefined {
    return Object.prototype.hasOwnProperty.call(CropVarietyConfigurations, key)
        ? (CropVarietyConfigurations as Record<string, CropVarietyConfiguration>)[key]
        : undefined;
}
